import TruckIcon from './TruckIcon';

export default TruckIcon;
